/**
Project: Voice Panel (c)
Title: Progress Indicator 
Description: Component to indicate the Voice setup progress
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import IntlUtil from "../../../../core/helpers/intl-util";
import { VoiceAdminConstants } from "../../common/settings/voice-admin-constants";

class ProgressIndicator extends Component {
  _intl_ns_vpa_voicesetup = "vpa_voicesetup";

  render() {
    return (
      <div id="vpa-voice-setup-progress">
        <ul className="progressbar">
          <li
            className={classNames(
              "steps",
              {
                active:
                  this.props.voiceSetupProgressPage ===
                  VoiceAdminConstants.VOICE_SETUP.PROGRESS.PRESENCE,
              },
              {
                completed:
                  this.props.voiceSetupProgressPage >
                  VoiceAdminConstants.VOICE_SETUP.PROGRESS.PRESENCE,
              }
            )}
          >
            <span
              className={classNames(
                "title",
                {
                  active:
                    this.props.voiceSetupProgressPage ===
                    VoiceAdminConstants.VOICE_SETUP.PROGRESS.PRESENCE,
                },
                {
                  completed:
                    this.props.voiceSetupProgressPage >
                    VoiceAdminConstants.VOICE_SETUP.PROGRESS.PRESENCE,
                }
              )}
            >
              {IntlUtil.getText(
                this._intl_ns_vpa_voicesetup,
                "content.progress.localGlobal"
              )}
            </span>
          </li>
          <li
            className={classNames(
              "steps",
              {
                active:
                  this.props.voiceSetupProgressPage ===
                  VoiceAdminConstants.VOICE_SETUP.PROGRESS.SETUP,
              },
              {
                completed:
                  this.props.voiceSetupProgressPage >
                  VoiceAdminConstants.VOICE_SETUP.PROGRESS.SETUP,
              }
            )}
          >
            <span
              className={classNames(
                "title",
                {
                  active:
                    this.props.voiceSetupProgressPage ===
                    VoiceAdminConstants.VOICE_SETUP.PROGRESS.SETUP,
                },
                {
                  completed:
                    this.props.voiceSetupProgressPage >
                    VoiceAdminConstants.VOICE_SETUP.PROGRESS.SETUP,
                }
              )}
            >
              {IntlUtil.getText(
                this._intl_ns_vpa_voicesetup,
                "content.progress.setup"
              )}
            </span>
          </li>
          <li
            className={classNames(
              "steps",
              {
                active:
                  this.props.voiceSetupProgressPage ===
                  VoiceAdminConstants.VOICE_SETUP.PROGRESS.SUMMARY,
              },
              {
                completed:
                  this.props.voiceSetupProgressPage >
                  VoiceAdminConstants.VOICE_SETUP.PROGRESS.SUMMARY,
              }
            )}
          >
            <span
              className={classNames(
                "title",
                {
                  active:
                    this.props.voiceSetupProgressPage ===
                    VoiceAdminConstants.VOICE_SETUP.PROGRESS.SUMMARY,
                },
                {
                  completed:
                    this.props.voiceSetupProgressPage >
                    VoiceAdminConstants.VOICE_SETUP.PROGRESS.SUMMARY,
                }
              )}
            >
              {IntlUtil.getText(
                this._intl_ns_vpa_voicesetup,
                "content.progress.complete"
              )}
            </span>
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  voiceSetupProgressPage: state.voiceSetupStore.voiceSetupProgressPage,
});

const mapActionToProps = {};

export default connect(mapStateToProps, mapActionToProps)(ProgressIndicator);
